import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
    HOME,
    SURVEYEDIT,
    SURVEYNEW,
    SURVEYQUESTIONS,
} from '../../../routes/paths';
import { MasterMessage } from '../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import {
    asyncDeleteSurvey,
    asyncGetSurveys,
} from '../../../services/survey.service';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import SubtitlesOffOutlinedIcon from '@mui/icons-material/SubtitlesOffOutlined';
import Swal from 'sweetalert2';
import { types } from '../../../redux/types';
import { useDispatch } from 'react-redux';

const SurveyList = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const { surveys }: any = MasterMessage;

    useEffect(() => {
        dispatch({ type: types.resetStepper });

        asyncGetSurveys(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                } else if (body.message !== undefined) {
                    SwalCustomClass.fire({
                        text: surveys[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, surveys]);

    const deleteSurvey = (rowId: string) => {
        Swal.fire({
            title: surveys.titleInactive,
            text: surveys.messageInactive,
            icon: 'error',
            iconColor: '#1d1d1d',
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: '#1d1d1d',
            confirmButtonText: 'SI',
            confirmButtonColor: '#1d1d1d',
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteSurvey(rowId).then((body: any) => {
                    if (body.items !== undefined) {
                        SwalCustomClass.fire({
                            text: surveys.messageInactiveOk,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                        });
                        asyncGetSurveys(page, pageSize).then((body: any) => {
                            if (body.items !== undefined) {
                                setRows(body.items.items);
                                setLengthRows(body.items.length);
                            }
                        });
                    } else {
                        SwalCustomClass.fire({
                            text: surveys[body.message],
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                });
            }
        });
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'code',
            headerName: 'Código',
            minWidth: 100,
            flex: 0.5,
        },
        {
            field: 'title',
            headerName: 'Titulo',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'description',
            headerName: 'Descripcion',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 100,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            renderCell: (val: any) => {
                switch (val.value) {
                    case 'active':
                        return (
                            <Chip
                                label="ACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="success"
                            />
                        );
                    case 'inactive':
                        return (
                            <Chip
                                label="INACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="error"
                            />
                        );
                    default:
                        return (
                            <Chip
                                label="EN PROCESO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="info"
                            />
                        );
                }
            },
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title={`${SURVEYQUESTIONS}/${row.id}`}>
                        <a
                            href={`${SURVEYQUESTIONS}/${row.id}`}
                            target="_blank"
                        >
                            <LinkIcon
                                fontSize="medium"
                                style={{ marginTop: 5 }}
                            />
                        </a>
                    </Tooltip>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() => navigate(`${SURVEYEDIT}/${row.id}`)}
                        >
                            <EditIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Deshabilitar">
                        <span>
                            <IconButton
                                size="small"
                                onClick={() => deleteSurvey(row.id)}
                                disabled={row.row.status === 'inactive'}
                            >
                                <SubtitlesOffOutlinedIcon
                                    type="submit"
                                    color={
                                        row.row.status === 'inactive'
                                            ? 'disabled'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </span>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <ListView
            title={surveys.titleList}
            titleButtonAdd={'Agregar'}
            startIconButtonAdd={<AddCircleIcon color="secondary" />}
            onClickAdd={() => navigate(SURVEYNEW)}
            onClickBack={() => navigate(HOME)}
            columns={columns}
            rows={rows}
            rowCount={lengthRows}
            disableRow={true}
            loading={loading}
            onSetPage={(paginationModel: any) => paginator(paginationModel)}
        />
    );
};

export default SurveyList;
